import { useEffect, useRef } from "react";

const BootstrapDateTimePicker = ({
  options = {},
  onHide,
  onChange,
  onError,
  onUpdate,
  name,
  className = "form-control",
  readOnly = true,
  value,
  defaultValue,
  placeholder,
}) => {
  const dateTimePickerRef = useRef(null);
  const dateTimePickerInstanceRef = useRef(null);

  // Initialize the datetimepicker only once
  useEffect(() => {
    const mergedOptions = {
      ...options,
      minDate: options.minDate || false,
      maxDate: options.maxDate || false,
    };

    const $element = $(dateTimePickerRef.current);
    $element.datetimepicker(mergedOptions);
    dateTimePickerInstanceRef.current = $element;

    // Attach event listeners
    if (onHide) {
      $element.on("dp.hide", onHide);
    }
    if (onChange) {
      $element.on("dp.change", onChange);
    }
    if (onError) {
      $element.on("dp.error", onError);
    }
    if (onUpdate) {
      $element.on("dp.update", onUpdate);
    }

    // Cleanup function
    return () => {
      if (dateTimePickerInstanceRef.current) {
        const pickerData = dateTimePickerInstanceRef.current.data();
        if (pickerData && pickerData.DateTimePicker) {
          pickerData.DateTimePicker.destroy();
        }
      }
    };
    // Only run on mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Update value if prop changes
  useEffect(() => {
    if (dateTimePickerInstanceRef.current && value !== undefined) {
      dateTimePickerInstanceRef.current.data("DateTimePicker").date(value);
    }
  }, [value]);

  return (
    <input
      type="text"
      ref={dateTimePickerRef}
      name={name}
      className={className}
      readOnly={readOnly}
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder}
    />
  );
};

export default BootstrapDateTimePicker;
